import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "pop_up pop_detail preview",
  style: {"display":"block","height":"80%"}
}
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "sub_page_con wrap_1120" }
const _hoisted_5 = { class: "bread_crumbs" }
const _hoisted_6 = { class: "icon_wrap" }
const _hoisted_7 = ["alt"]
const _hoisted_8 = { class: "faq_title" }
const _hoisted_9 = { class: "sub_page_con_view con_view" }
const _hoisted_10 = { class: "tit_wrap flex_wrap" }
const _hoisted_11 = { class: "con_tit" }
const _hoisted_12 = { class: "con_tit_info" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "writer_info" }
const _hoisted_15 = {
  key: 0,
  class: "con_info_wrap"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "info_desc" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "info_desc" }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "info_desc" }
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { class: "info_desc" }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { class: "info_desc" }
const _hoisted_26 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "close_btn",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: "img/close.png",
          alt: "닫기"
        }, null, -1)
      ]))]),
      _createElementVNode("div", {
        class: _normalizeClass(["sub_page", [$setup.state.type !== 'news' ? '_activity' : '_news']]),
        style: {"max-height":"100%","overflow-y":"auto"}
      }, [
        _createElementVNode("section", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "banner_wrap wrap_1120" }, [
            _createElementVNode("h2", null, "소개")
          ], -1)),
          _createElementVNode("div", {
            class: "sub_menu_tab wrap_1120",
            innerHTML: $setup.state.header
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createStaticVNode("<a href=\"\" class=\"icon_wrap\" data-v-3fb9b7bf><img src=\"img/home_icon.png\" alt=\"홈\" data-v-3fb9b7bf></a><span class=\"icon_wrap\" data-v-3fb9b7bf><img src=\"img/part_icon.png\" alt=\"시민참여 활동\" data-v-3fb9b7bf></span><a href=\"\" data-v-3fb9b7bf>시민참여 활동</a><span class=\"icon_wrap\" data-v-3fb9b7bf><img src=\"img/part_icon.png\" alt=\"반성매매 시민활동\" data-v-3fb9b7bf></span><a href=\"\" data-v-3fb9b7bf>반성매매 시민활동</a>", 5)),
            _createElementVNode("span", _hoisted_6, [
              _createElementVNode("img", {
                src: "img/part_icon.png",
                alt: $setup.state.title
              }, null, 8, _hoisted_7)
            ]),
            _createElementVNode("span", _hoisted_8, _toDisplayString($setup.state.title), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString($setup.state.title), 1),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString($setup.CommonUtils.dateFormat(new Date(), ".", true)), 1),
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "" }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("img", {
                      src: "img/view.png",
                      alt: ""
                    })
                  ]),
                  _createTextVNode(" 0 ")
                ], -1)),
                _createElementVNode("span", _hoisted_14, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", null, "작성자", -1)),
                  _createTextVNode(" " + _toDisplayString($setup.user.userInfo.name), 1)
                ])
              ])
            ]),
            ($setup.state.type !== 'news')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  ($setup.state.data.activityStartDate && $setup.state.data.activityEndDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "info_tit" }, [
                          _createElementVNode("img", {
                            src: "img/info_icon_01.png",
                            alt: "활동기간"
                          }),
                          _createTextVNode(" 활동기간 ")
                        ], -1)),
                        _createElementVNode("span", _hoisted_17, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.activityStartDate), ".", false) +
                                    "-" +
                                    $setup.CommonUtils.dateFormat(new Date($setup.state.data.activityEndDate), ".", false)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.data.recruitmentStartDate && $setup.state.data.recruitmentEndDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "info_tit" }, [
                          _createElementVNode("img", {
                            src: "img/info_icon_02.png",
                            alt: "모집기간"
                          }),
                          _createTextVNode(" 모집기간 ")
                        ], -1)),
                        _createElementVNode("span", _hoisted_19, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.recruitmentStartDate), ".", false) +
                                    "-" +
                                    $setup.CommonUtils.dateFormat(new Date($setup.state.data.recruitmentEndDate), ".", false)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.data.endDate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "info_tit" }, [
                          _createElementVNode("img", {
                            src: "img/info_icon_02.png",
                            alt: "신청 마감"
                          }),
                          _createTextVNode(" 신청 마감 ")
                        ], -1)),
                        _createElementVNode("span", _hoisted_21, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.endDate), ".", false)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.data.cntMember > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "info_tit" }, [
                          _createElementVNode("img", {
                            src: "img/info_icon_03.png",
                            alt: "모집인원"
                          }),
                          _createTextVNode(" 모집인원 ")
                        ], -1)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString($setup.state.data.cntMember) + "명", 1)
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.data.address)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "info_tit" }, [
                          _createElementVNode("img", {
                            src: "img/info_icon_04.png",
                            alt: "장소"
                          }),
                          _createTextVNode(" 장소 ")
                        ], -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString($setup.state.data.address) + " " + _toDisplayString($setup.state.data.addressDetail), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "content_wrap",
              innerHTML: $setup.state.content
            }, null, 8, _hoisted_26),
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "btn_wrap _default right_btn _board_type" }, [
              _createElementVNode("button", {
                class: "common_btn",
                type: "button"
              }, "목록")
            ], -1))
          ])
        ])
      ], 2)
    ])
  ], 64))
}